import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";

import Card from "../../../Components/Card/Card";
import { getLabel } from "../../../Services/Language/LanguageService"; 
import { baseLang } from "../../../Lang/BaseLang"; 
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext"; 
import { AuthContext } from "../../../Context/AuthContext/AuthContext"; 
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService"; 

import { getCalendarioMensual } from "../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import CalendarioMensualCRUD from "./CalendarioOperativoMensualCRUD/CalendarioMensualCRUD";


const CalendarioOperativoScreen = ({CSM = false}) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [calendarioMensual, setCalendarioMensual] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);


  const getInfo = async () => {
    setLoading(true);
    const tipoT = await getCalendarioMensual()
    setCalendarioMensual(tipoT);
    setLoading(false);
  };



  const columns = [
    {
      field: "IdMes",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
    },
    {
      field: "NoMes",
      header: "NoMes",
      handerEn: 'NoMonth',
      className: "Xsmall",
    },
    {
      field: "MesEsLargo",
      header: "Mes",                
      handerEn: 'Month',
      className: "medium",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "InicioMes",
      header: "Inicio Mes",
      headerEn: "",
      className: "Xlarge",
      flex: 1,

    },
    {
      field: "FinMes",
      header: "Fin Mes",
      headerEn: "",
      className: "Xlarge",
      flex: 1,
    },
    {
      field: "NoSemanas",
      header: "NoSemanas",
      headerEn: "",
      className: "Xlarge",
      Format: 'Currency',
      flex: 1,
    },
    {
      field: "TasaCambio",
      header: "Tasa de Cambio",
      headerEn: "",
      className: "Xlarge",
      flex: 1,
      Format: 'Currency',
    },
    {
      field: "Anio",
      header: "Año",
      headerEn: "Year",
      className: "Xlarge",
    },
    {
      field: "PorcentajeAlgodon",
      header: "% Algodón",
      className: "medium",
      Format: 'Porcentaje',
    },
    {
      field: "PorcentajeSintetico",
      header: "% Sintetico",
      className: "medium",
      Format: 'Porcentaje',
    },
    {
      field: "IdMes",
      className: "colum-width-small",
      header: "",
      Format: "Botones",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(rowData);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: calendarioMensual,
    loading: loading,
  };

  
  const onHide = () => {
    setShowDialog(false);
    getInfo();
}

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "calendarioO", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "calendarioO", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            {/* <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            /> */}
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      <Dialog
        header={<div style={{ textTransform: "capitalize" }}>Editar Mes</div>}
        visible={showDialog}
        style={{ width: "50vw" }}
        onHide={onHide}
        closeOnEscape={false}
      >
        <CalendarioMensualCRUD
          editMes={showDialog}
          onHide={onHide}
          actualizarScreen={getInfo}
          CSM={CSM}
        />
      </Dialog>

    </div>
  );
};

export default CalendarioOperativoScreen;
